import React,{useState,useEffect} from 'react';
import { useSelector} from "react-redux";
import {Button,Drawer,Input,Space,Form,Select,InputNumber } from 'antd';
import { DownloadOutlined,PlusCircleFilled,EditFilled ,DeleteFilled} from '@ant-design/icons';

import debounce from 'lodash/debounce';
import useAxios from './../../../CustomHooks/useAxios';
import DebounceSelect from './../../DebounceSelect'
const {TextArea} = Input;
const { Option } = Select;

export default function Edit({item,setRefressSearch,setVisibleEdit,setSelectedItem}) {
  console.log("[Edit]:item=",item);
  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const user = useSelector((state) => state.loginReducer.user);
  const {axiosi}=useAxios();
  const [form] = Form.useForm();
  
  const [companyid, setCompanyid] = React.useState({value:item.company_id,label:item.company_name});
  const [code,setCode] = useState('');
  const [name,setName] = useState('');
  const [paramType,setParamType] = useState('');

    const onFinishAdd=async (values)=>{
        let adddata={...values,company_id:companyid?.value   };
       
        try {
            const kq=await axiosi.put(`note_param_setting/${item.id}`,adddata);
            console.log("[onFinishAdd]:kq=",kq) ;
            // form.resetFields();
            setSelectedItem(null);
            setVisibleEdit(false);
            setRefressSearch(pre=>!pre);
        } catch (error){
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log("error.response.data:",error.response.data);
                console.log("error.response.status:",error.response.status);
                console.log("error.response.headers:",error.response.headers);
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log("error.request :",error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error error.message', error.message);
              }
              console.log("error.config:",error.config);
        }
    }
    const onFinishFailedAdd=(error)=>{
        console.log("[onFinishFailedAdd]:error=",error);
    }

   
    const handleOnChangeCompanyName=async(value)=>{
          setCompanyid(value);
          
    }

    async function fetchUserList(company_name) {        
      console.log('fetching user', company_name);
      const body=await axiosi.get('companies',{params:{company_name,pageSize:100}} );
      if (body?.data?.rows) {
          return body?.data?.rows.map((user) => ({
              label: user.company_name,
               value: user.id,
              //  value:{id: user.id,company_code:user.company_code},
               company_code:user.company_code,
             }));
      }
      else {
          const a=[{label:"---no data---",value:""}]
          return a.map(i=> (i))
      }
     
  }
    



  return (<>
  
        <Form form={form}
      name="basic"
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 15 }}
      initialValues={item}
      onFinish={onFinishAdd}
      onFinishFailed={onFinishFailedAdd}
      autoComplete="off"
    >
      

        <Form.Item className={hideItem}
        label="Company Name"
        // name="company_name"
        // rules={[{ required: (hideItem!=="hideItem"), message: 'Please input a company_name!' }]}
      >
        <DebounceSelect
          showSearch={true}
          value={companyid}
          placeholder="Select users"
          fetchOptions={fetchUserList}
          onChange={handleOnChangeCompanyName}          
          style={{  width: '100%', }}
        />
      </Form.Item>
      <Form.Item
      
      label="Param Name :"
        name="param_name"
        rules={[{ required: true, message: 'Select a Param Type!' }]}
        >
                 
            <Select
            //   value={paramType}
              style={{ width: "100%" }}
            //   onChange={(value) =>{ 
            //     console.log(value)
            //     setParamType(value)}}
            >
              <Option value="">Select a Param Type</Option>
              <Option value="tkNoteCategory">Ticket Note Category</Option>
              <Option value="tkNoteStatus">Ticket Note Status</Option>
              <Option value="obCallStatus">Outbound Call Status</Option>
              <Option value="obDataStatus">Outbound Data Status</Option>
            </Select>
          
        
      </Form.Item>
      <Form.Item
        label="Code :"
        name="code"
        rules={[{ required: true, message: 'Please input a department name!' }]}
      >
        <Input  />        
      </Form.Item>
      <Form.Item
        label="Name :"
        name="name"
        rules={[{ required: true, message: 'Please input a survey name!' }]}
      >
        <Input  />  
        </Form.Item>
        
      <Form.Item
      
      label="Is Disable :"
        name="is_disable"
        rules={[{ required: true, message: 'Select a Param Type!' }]}
        >
                 
            <Select
            //   value={paramType}
              style={{ width: "100%" }}
            //   onChange={(value) =>{ 
            //     console.log(value)
            //     setParamType(value)}}
            >
              <Option value="">Set Enable/Disable</Option>
              <Option value={0}>False</Option>
              <Option value={1}>True</Option>
              
            </Select>
          
        
      </Form.Item>
        
      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
        </Form>
  </>);
}
